const useSubpageLayout = () => {
  return {}
}

export default useSubpageLayout
